/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useLayoutEffect } from 'react';
import { DIProps, DI } from '../../../Core';
import queryString from 'query-string';
import { Card, Button, Divider, InlineStack, Page, Text, BlockStack } from '@shopify/polaris';
import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';

let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

function ShowMessage(props: DIProps): JSX.Element {
    const [socketConnected, setSoceketConnected] = useState<boolean>(false)
    const queryParams: any = queryString.parse(props.location.search);
    setTimeout(() => {
        window.close();
    }, queryParams?.connected_source ? 5000 : 3000);

    function renderConnectedStoreNames() {
        let list: any = queryParams?.connected_source?.toString() || undefined;
        return list?.split(',')?.map((ele: any) => <li key={ele}>{ele}</li>) ?? 'multiple accounts.';
    }


    useLayoutEffect(() => {
        socket = io('https://amazon.websocket.cedcommerce.com/', { path: '/onboarding.live' });;
        socket.on('connect', () => {
            setSoceketConnected(true)
            socket.emit("setRemoteShopID", queryParams?.remote_shop_id ?? '');
        })
        return () => {
            socket.disconnect()
        }
    }, [])

    function displayMessage() {
        if (queryParams?.connected_source) {
            return <React.Fragment>
                <Text as='p'>We're sorry to inform you that you cannot connect the same Amazon account with multiple users. It looks like the account is already connected with
                    <Text as='span'>
                        {renderConnectedStoreNames()}
                    </Text>
                    To reconnect, you will need to first disconnect the Amazon account from this store and then wait for 48 hours before connecting it again to another user.</Text>
                <Text as='p'>
                    In case you don't want to wait for 48 hrs then we recommend that you can reach out to our support team at <a href={`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`}>support@cedcommerce.com</a>  who will be more than happy to assist you. They are available 24/7 and can help you resolve your issue in no time.
                </Text>
            </React.Fragment>
        }
        else if (queryParams.success == "true") {
            return 'Success :  ' + queryParams.message;
        }
        else {
            return 'Error : ' + queryParams.message;
        }
    }

    return (
        <Page>

            <Card roundedAbove='sm'>
                <BlockStack gap="600">
                    <InlineStack align='center'>
                        <img
                            src="https://icon-library.com/images/notification-icon-png/notification-icon-png-11.jpg"
                            height="150"
                        />
                    </InlineStack>
                    <Divider borderWidth='050' />
                    <InlineStack align='center'>
                        <Text variant="headingXl" as='p' fontWeight='regular'>
                            {displayMessage()}
                        </Text>
                    </InlineStack>
                    <Divider borderWidth='050' />
                    <InlineStack align='center'>
                        <Button onClick={() => {
                            if (!socketConnected) {
                                props.error('Please wait, connecting you with the server.')
                            } else {
                                window.close()
                            }
                        }}>
                            Close
                        </Button>
                    </InlineStack>
                </BlockStack>
            </Card>
        </Page>
    );
}

export default DI(ShowMessage);